const STRIPE_ERROR_MAP: Record<string, string> = {
  incomplete_number:          'Inserisci il numero di carta completo.',
  invalid_number:             'Il numero di carta non è valido.',
  incomplete_expiry:          'Inserisci la data di scadenza.',
  invalid_expiry_year_past:   'La carta è scaduta.',
  invalid_expiry_month_past:  'La carta è scaduta.',
  incomplete_cvc:             'Inserisci il codice di sicurezza (CVC).',
  invalid_cvc:                'Il codice di sicurezza (CVC) non è valido.',
  expired_card:               'La carta è scaduta.',
  incorrect_cvc:              'Il codice di sicurezza (CVC) non è corretto.',
  incorrect_number:           'Il numero di carta non è corretto.',
  card_declined:              'La carta è stata rifiutata dalla banca.',
  insufficient_funds:         'Fondi insufficienti sulla carta.',
  do_not_honor:               'La carta è stata rifiutata dalla banca emittente.',
  authentication_required:    'La carta richiede autenticazione 3D Secure.',
  card_not_supported:         'Questa carta non è supportata.',
  processing_error:           'Errore durante l\'elaborazione. Riprova tra qualche istante.',
  invalid_expiry_year:        'L\'anno di scadenza non è valido.',
};

export function stripeErrorMessage(error: { code?: string; message?: string }): string {
  if (error.code && STRIPE_ERROR_MAP[error.code]) {
    return STRIPE_ERROR_MAP[error.code];
  }
  return error.message || 'Controlla i dati della carta e riprova.';
}
